import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import dayjs from "dayjs";
import { FaPen } from "react-icons/fa";
import ClearIcon from "@mui/icons-material/Clear";
import { FaCalendarAlt } from "react-icons/fa";
import { Edit3 } from "lucide-react";
import { Sparkles } from "lucide-react";
import { Plus } from "lucide-react";
import { Trash2 } from "lucide-react";
import { Tooltip } from "@mui/material";
import { FaEye } from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  FileText,
  Search,
  DollarSign,
  Building2,
  CreditCard,
  Users,
  Package,
  TrendingUp,
  TrendingDown,
  Briefcase,
  Home,
  Menu,
  X,
  TicketCheck,
  Landmark,
  HandCoins,
} from "lucide-react";

import { format, set } from "date-fns";
import ic_checkmark from "../../utils/ic_checkmark_button.png";
import ic_no_data from "../../utils/ic_no_data_to_show.svg";
import ic_timeline_circle_indicator from "../../utils/ic_timeline_icon.svg";

// import ModifyVoucher from "./ModifyVoucher";
import { useLocation, useNavigate } from "react-router-dom";

import { use } from "react";
import VoucherSetupBill from "../../VoucherFolder/VoucherSetupBill";
// import PettyCashAccountPopup from "./PettyCashAccountPopup";
import CreditCustomerList from "../common/CreditCustomerList";
import Modal from "../common/CommonModal";

const PettyCash = () => {
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment") || "-";
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const USEROBJECT = JSON.parse(localStorage.getItem("currentUser")) || {};
  const USER = USEROBJECT[0];
  const [selectedVoucherType, setSelectedVoucherType] = useState("PC");
  const [selectedVoucherDescription, setSelectedVoucherDescription] =
    useState("Voucher");

  const [pvnoFromAPI, setPVnoFromAPI] = useState("");
  const [maxVoucherNo, setMaxVoucherNo] = useState("");
  const [disableModify, setDisableModify] = useState(true);
  // const [disableGenerate, setDisableGenerate] = useState(true);
  const [disableGenerate, setDisableGenerate] = useState(false);
  const [voucherTypeList, setVoucherTypeList] = useState([]);
  const [voucherTimeLineList, setVoucherTimeLineList] = useState([]);
  const [jvDate, setJvDate] = useState(new Date().toISOString().split("T")[0]);
  const [jvRecurringDate, setJvRecurringDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [accounts, setAccounts] = useState([]);
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);
  const [searchVoucherAccountTerm, setSearchVoucherAccountTerm] = useState("");
  const [frequency, setFrequency] = useState("");
  const [value, setValue] = useState("CASH");
  const [inputVoucherValue, setInputVoucherValue] = useState("");
  const [inputVoucherValueAccount, setInputVoucherValueAccount] = useState("");
  const [inputVoucherValueDescription, setInputVoucherValueDescription] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [filteredPDCAccounts, setFilteredPDCAccounts] = useState([]);
  const [ty, setTY] = useState([]);
  const [selectedVoucherAccount, setSelectedVoucherAccount] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyRate, setSelectedCurrencyRate] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [finalAmount, setFinalAmount] = useState(null);

  const [pdcDropdownOpenIndex, setPdcDropdownOpenIndex] = useState(null);
  const [pdcHighlightedIndex, setPdcHighlightedIndex] = useState(-1);
  const [pdcSearchTerm, setPdcSearchTerm] = useState("");
  const [pdcModalOpen, setPdcModalOpen] = useState(false);
  const [recurringJournal, setRecurringJournal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSavePopup, setOpenSavePopup] = useState(false);
  const [openModifyPopup, setOpenModifiedPopup] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [openErrorModifySnackbar, setOpenErrorModifySnackbar] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [isCheckedRepeatAmount, setIsCheckedRepeatAmount] = useState(false);
  const [isCheckedRepeatDesc, setIsCheckedRepeatDesc] = useState(false);
  const [isVatOn, setIsVatOn] = useState(false);
  const [modifyPopup, setModifyPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [modifyVoucherPage, setModifyVoucherPage] = useState(false);
  const [sumOfAmount, setSumOfAmount] = useState(0);
  const [sumOfDebit, setSumOfDebit] = useState(0);
  const [sumOfCredit, setSumOfCredit] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState("daily");
  const [modifyVoucherNo, setModifyVoucherNo] = useState("");

  const [savedVNO, setSavedVNO] = useState("");
  const [modifiedVNO, setModifiedVNO] = useState("");
  const [generatedEntriesState, setGeneratedEntriesState] = useState([]);
  const [pcAmount, setPCAmount] = useState(0);
  const [crPCModalOpen, setCrPCModalOpen] = useState(false);
  const [drPCModalOpen, setDrPCModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountDesc, setSelectedAccountDesc] = useState("");
  const [selectedAccountBal, setSelectedAccountBal] = useState("");

  const [docDate, setDocDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const initialVoucherEntries = [
    {
      account: "",
      description: "",
      INV: "",
      DESCR: "",
      AMOUNT: 0,
      vatOn: false,
      vatAmt: "",
      total: "",
      trn: "",
      x: "",
      // docDate: "",
      // ty: "D",
      // CUR: "",
      // rate: 1,
      // FCBalAmt: 0,
      // credit: 0,
      // JOBCODE: "",
      // INVDATE: "",
    },
  ];

  // const [entries, setEntries] = useState(initialVoucherEntries);
  const [entries, setEntries] = useState([]);
  const [modifyButton, setModifyButton] = useState(false);
  const [isCorrectLength, setIsCorrectLength] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [selectedAccountsState, setSelectedAccountsState] = useState([]);
  const [setupBillAccount, setSetupBillAccount] = useState("");
  const [isAccountFocused, setIsAccountFocused] = useState(false);
  const [isRecurringInModifyData, setIsRecurringInModifyData] = useState(false);
  const accountRowContainerRef = useRef(null);
  const accountContainerRef = useRef(null);
  const setupBillContainerRef = useRef(null);
  const accountRefs = useRef([]);
  const voucherDropdownRefs = useRef([]);
  const accountNameRefs = useRef([]);
  const invRefs = useRef([]);
  const descriptionRefs = useRef([]);
  const tyRefs = useRef([]);
  const amountRefs = useRef([]);
  const curRefs = useRef([]);
  const rateRefs = useRef([]);
  const fcBalRefs = useRef([]);
  const chqNoRefs = useRef([]);
  const chqDateRefs = useRef([]);
  const reccurringDateRefs = useRef([]);
  const bankRefs = useRef([]);
  const pdcAccRefs = useRef([]);
  const xRefs = useRef([]);
  const jobCodeRefs = useRef([]);
  const cCenterRefs = useRef([]);
  const costCodeRefs = useRef([]);
  const vatAmtRefs = useRef([]);
  const trnRefs = useRef([]);
  const totalRefs = useRef([]);
  const isVatRefs = useRef([]);
  const pdcDropdownRefs = useRef([]);
  const voucherTypeRefs = useRef(null);
  const [comment, setComment] = useState("");

  // const difference = (sumOfAmount - pcAmount).toFixed(2);
  const difference = (sumOfAmount - sumOfAmount).toFixed(2);
  const isCommentEmpty = !comment.trim();
  const isCreditZero = Number(pcAmount) === 0;
  const isDebitZero = Number(sumOfDebit) === 0;
  const isDifferenceZero = Number(difference) === 0;
  const isAnyAccountEmpty = entries.some((entry) => !entry?.account?.trim());
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [jobCode, setJobCode] = useState("");
  const [deptDesc, setDeptDesc] = useState("");
  const [jobCodeList, setJobCodeList] = useState([]);

  const crInputRef = useRef();

  const location = useLocation();

  const modifyVoucherDataFromView = location.state?.modifyVoucherData;

  useEffect(() => {
    if (modifyVoucherDataFromView) {
      console.log(
        "modifyVType from list: ",
        modifyVoucherDataFromView.modifyVType,
      );
      setPVnoFromAPI(modifyVoucherDataFromView.modifyVNO);
      onSubmitVoucherModifyNo(modifyVoucherDataFromView.modifyVNO);
    }
  }, [modifyVoucherDataFromView, pvnoFromAPI]);

  const isAnyAccountLength = entries.some(
    (entry) => entry.account?.length !== 8,
  );

  const isSelectedAccount = selectedAccountsState.some(
    (state) => state === false,
  );

  useEffect(() => {
    console.log("🚀 ~ Voucher ~ isSelectedAccount:", isSelectedAccount);
  }, [selectedAccountsState]);

  const isDisabled =
    isCommentEmpty ||
    // isCreditZero ||
    // isDebitZero ||
    !isDifferenceZero ||
    isAnyAccountEmpty ||
    isAnyAccountLength ||
    isSelectedAccount;

  // const isRecurringDisabled =
  //   isAnyAccountEmpty || !isDifferenceZero || isDebitZero || isCreditZero;
  const isRecurringDisabled = !isDifferenceZero;

  useEffect(() => {
    setSelectedAccountsState((prev) => {
      const newLength = entries.length;
      const updated = [...prev];

      // Extend array if new rows are added
      while (updated.length < newLength) {
        updated.push(false); // default: not selected
      }

      // Trim array if rows were removed
      return updated.slice(0, newLength);
    });
  }, [entries.length]);

  // useEffect(() => {
  //   if (value) {
  //     fetchAccountList(value);
  //   }
  // }, [value]);

  useEffect(() => {
    setFilteredAccounts(
      searchVoucherAccountTerm
        ? accounts.filter(
          (acc) =>
            acc.ACCOUNT.toLowerCase().includes(
              searchVoucherAccountTerm.toLowerCase(),
            ) ||
            acc.DESCRIPTION.toLowerCase().includes(
              searchVoucherAccountTerm.toLowerCase(),
            ),
        )
        : accounts,
    );
  }, [accounts, searchVoucherAccountTerm]);

  useEffect(() => {
    setFilteredPDCAccounts(
      pdcSearchTerm
        ? accounts?.filter(
          (acc) =>
            acc.ACCOUNT?.toLowerCase().includes(
              pdcSearchTerm.toLowerCase(),
            ) ||
            acc.DESCRIPTION?.toLowerCase().includes(
              pdcSearchTerm.toLowerCase(),
            ),
        )
        : accounts,
    );
  }, [pdcSearchTerm, accounts]);

  useEffect(() => {
    crInputRef.current?.focus();

    handleVoucherTypeChange("PC");
    fetchVoucherTypeList();
    fetchAccountList("CASH");
    if (accountRefs.current[0]) {
      accountRefs.current[0].focus();
    }
    fetchCurrencyList();
    if (voucherTypeRefs.current) {
      voucherTypeRefs.current.focus();
    }
  }, []);

  useEffect(() => {
    if (selectedVoucherType) {
      fetchVoucherNo();
    }
  }, [selectedVoucherType]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideDropdown = voucherDropdownRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );
      const clickedInsideAccount = accountRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );

      if (!clickedInsideDropdown && !clickedInsideAccount) {
        setDropdownOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideDropdown = pdcDropdownRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );
      const clickedInsideAccount = pdcAccRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );

      if (!clickedInsideDropdown && !clickedInsideAccount) {
        setPdcDropdownOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchVoucherNo = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GetNew/${selectedVoucherType}/-`;

    try {
      const response = await axios.get(apiUrl);
      const voucherNo = response.data[0].NEXT_NO;
      setDisableModify(false);
      setPVnoFromAPI(voucherNo || "");
      setMaxVoucherNo(voucherNo || "");

      fetchVoucherTimeline(voucherNo);
    } catch (err) {
      console.error("Error while fetching Voucher No:", err);
    }
  };

  const fetchVoucherTypeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/VOUCHER/-/-`;

    try {
      const response = await axios.get(url);
      setVoucherTypeList(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };

  const fetchVoucherTimeline = async (voucherNo) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";

    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${COMPANY_CODE}/PETTYCASH/-/-/${selectedVoucherType}/${voucherNo}/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;

    try {
      const response = await axios.get(url);
      console.log("Timeline Data:", response.data);
      setVoucherTimeLineList(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Timeline :", err);
    }
  };

  const fetchAccountList = async (valueToAPI) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";

    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setAccounts(response.data || []);
    } catch (err) {
      console.error("Error while fetching voucher accounts", err);
    } finally {
      setLoading(false);
    }
  };

  // const handleSelectAccount = (index, selectedAccount) => {
  //   const updatedEntries = [...entries];
  //   updatedEntries[index] = {
  //     ...updatedEntries[index],
  //     account: selectedAccount.ACCOUNT,
  //     description: selectedAccount.DESCRIPTION,
  //   };
  //   setEntries(updatedEntries);
  //   setSelectedVoucherAccount(selectedAccount);
  //   setDropdownOpenIndex(null);
  //   setSearchVoucherAccountTerm("");
  //   setVoucherModalOpen(false);
  // };

  const handleSelectAccount = (rowIndex, acc) => {
    // Update selected account in state
    setSelectedVoucherAccount(acc);

    // Update the row fields
    handleChange(rowIndex, "account", acc.ACCOUNT);
    handleChange(rowIndex, "description", acc.DESCRIPTION);

    // Mark this row's account as selected (remove red background)
    setSelectedAccountsState((prev) => {
      const updated = [...prev];
      updated[rowIndex] = true;
      return updated;
    });

    // Close modal
    setVoucherModalOpen(false);

    // Reset dropdown highlight states
    setDropdownOpenIndex(null);
    setHighlightedIndex(-1);

    // Focus the next input (INV field or whichever comes next)
    invRefs.current[rowIndex]?.focus();
  };

  const handleAddRow = () => {
    const lastRow = entries.length > 0 ? entries[entries.length - 1] : null;
    setEntries([
      ...entries,
      {
        account: "",
        description: "",
        INV: "",
        DESCR: isCheckedRepeatDesc && lastRow ? lastRow.DESCR : "",
        AMOUNT: isCheckedRepeatAmount && lastRow ? lastRow.AMOUNT : 0,
        vatOn: false,
        vatAmt: "",
        total: "",
        trn: "",
        x: "",

        // ty: lastRow?.ty === "D" ? "C" : "D",
        // CUR: "AED",
        // rate: 1,
        // FCBalAmt: 0,
        // chqNo: "",
        // chqDate: "",
        // docDate: "",
        // Bank: "",
        // pdcAcc: "",
        // JOBCODE: "",
      },
    ]);
    // setTY((prev) => [...prev, lastRow?.ty === "D" ? "C" : "D"]);

    setTimeout(() => {
      // wait until new row is rendered
      const lastIndex = accountRefs.current.length - 1;
      accountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
  };

  // const handleChange = (index, field, value) => {
  //   const newEntries = [...entries];
  //   newEntries[index][field] = field === "account" ? value : value || "";
  //   setEntries(newEntries);
  //   if (field === "account") {
  //     setSearchVoucherAccountTerm(value);
  //     setDropdownOpenIndex(index);
  //   }
  // };

  // const handleChange = (index, field, value) => {
  //   setEntries((prevEntries) => {
  //     const updatedEntries = [...prevEntries];
  //     const updatedRow = { ...updatedEntries[index], [field]: value || "" };
  //     updatedEntries[index] = updatedRow;
  //     return updatedEntries;
  //   });

  //   if (field === "account") {
  //     setSearchVoucherAccountTerm(value);
  //     setDropdownOpenIndex(index);
  //   }
  // };

  const handleChange = (index, field, value) => {
    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];

      // Sync both INV and ref fields
      if (field === "INV") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          INV: value || "",
          ref: value || "", // Keep ref in sync for API
        };
      } else if (field === "account") {
        // const trimmedValue = value.trim();

        const matchedAccount = filteredAccounts?.find(
          (acc) =>
            acc.account?.toLowerCase() === value?.toLowerCase() ||
            acc.description?.toLowerCase() === value?.toLowerCase(),
        );

        setSetupBillAccount(matchedAccount ? matchedAccount.ACCOUNT : value);
        updatedEntries[index] = {
          ...updatedEntries[index],
          account: matchedAccount ? matchedAccount.ACCOUNT : value || "",
        };
      } else if (field === "accdesc") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          accdesc: value || "",
          description: value || "", // Keep ref in sync for API
        };
      } else if (field === "DESCR") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          LPONO: value || "",
          DESCR: value || "",
        };
      } else if (field === "AMOUNT") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          AMOUNT: value || "",
          amount: value || "",
        };
      } else if (field === "chqDate") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          chqDate: value || "",
          chqdate: value || "",
        };
      } else if (field === "Bank") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          Bank: value || "",
          bank: value || "",
        };
      } else if (field === "pdcAcc") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          pdcAcc: value || "",
          pdc_acc: value || "",
        };
      } else if (field === "JOBCODE") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          JOBCODE: value || "",
          job_code: value || "",
        };
      } else if (field === "costCode") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          costCode: value || "",
          COSTCODE: value || "",
        };
      } else if (field === "CCENTER") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          CCENTER: value || "",
          ccno: value || "",
        };
      } else if (field === "trn") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          ttref: value || "",
          trn: value || "",
        };
      } else {
        updatedEntries[index] = {
          ...updatedEntries[index],
          [field]: value || "",
        };
      }

      return updatedEntries;
    });

    if (field === "account") {
      setSearchVoucherAccountTerm(value);
      setDropdownOpenIndex(index);
    }
  };

  const handleChangePdcAcc = (index, field, value) => {
    setEntries((prevEntries) => {
      // clone previous entries safely
      const newEntries = [...prevEntries];

      // ensure the index exists before setting
      if (!newEntries[index]) return prevEntries;

      // assign new value (like your handleChange)
      newEntries[index][field] = field === "pdcAcc" ? value : value || "";

      // update dropdown & search term if needed
      if (field === "pdcAcc") {
        setPdcSearchTerm(value);
        setPdcDropdownOpenIndex(index);
      }

      return newEntries;
    });
  };

  // const handleChangeAmountEntry = (index, field, value) => {
  //   console.log(
  //     "🚀 ~ handleChangeAmountEntry ~ handleChangeAmountEntry is called:"
  //   );

  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const amount = parseFloat(value) || 0;
  //     const rate = parseFloat(selectedCurrencyRate) || 1; // ✅ use global state

  //     updated[index].AMOUNT = amount;
  //     updated[index].FCBalAmt = Number(amount / rate).toFixed(2); // ✅ proper math

  //     return updated;
  //     // updated[index] = {
  //     //   ...updated[index],
  //     //   amount: parseFloat(value) || 0,
  //     //   AMOUNT: parseFloat(value) || 0,
  //     // };
  //     // return updated;
  //   });
  // };

  const handleChangeAmountEntry = (index, field, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const amount = parseFloat(value) || 0;
      const rate = parseFloat(updated[index].rate) || 1;

      updated[index] = {
        ...updated[index],
        AMOUNT: amount,
        FCBalAmt: Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  const handleChangeAmountModify = (index, field, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const amount = parseFloat(value) || 0;
      const rate = parseFloat(updated[index].rate) || 1;

      updated[index] = {
        ...updated[index],
        amount: amount,
        FCBalAmt: Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  // const handleChangeAmountModify = (index, field, value) => {
  //   console.log(
  //     "🚀 ~ handleChangeAmountModify ~ handleChangeAmountModify is called:"
  //   );

  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     // const amount = parseFloat(value) || 0;
  //     // const rate = parseFloat(selectedCurrencyRate) || 1; // ✅ use global state

  //     // updated[index].AMOUNT = amount;
  //     // updated[index].FCBalAmt = Number(amount / rate).toFixed(2); // ✅ proper math

  //     // return updated;
  //     updated[index] = {
  //       ...updated[index],
  //       amount: parseFloat(value) || 0,
  //       AMOUNT: parseFloat(value) || 0,
  //     };
  //     return updated;
  //   });
  // };

  const handleChangeFCBalAmt = (index, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const fcBalAmt = parseFloat(value) || 0;
      const rate = parseFloat(updated[index].rate) || 1;

      updated[index] = {
        ...updated[index],
        FCBalAmt: fcBalAmt,
        AMOUNT: Number(fcBalAmt * rate).toFixed(2),
      };
      return updated;
    });
  };

  // const handleChangeFCBalAmt = (index, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const fcBalAmt = parseFloat(value) || 0;
  //     const rate = parseFloat(selectedCurrencyRate) || 1; // ✅ use global state

  //     updated[index].FCBalAmt = fcBalAmt;
  //     updated[index].AMOUNT = Number(fcBalAmt * rate).toFixed(2); // ✅ reverse math

  //     return updated;
  //   });
  // };

  const handleChangeRate = (index, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const rate = parseFloat(value) || 1;
      const fcBalAmt = parseFloat(updated[index].FCBalAmt) || 0;

      updated[index] = {
        ...updated[index],
        rate,
        AMOUNT: Number(fcBalAmt * rate).toFixed(2),
      };
      return updated;
    });
  };

  const handleTyData = (index) => {
    setTY((prev) =>
      prev.map((value, i) =>
        i === index ? (value === "D" ? "C" : "D") : value,
      ),
    );
    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        ty: newEntries[index].ty === "C" ? "D" : "C",
      };
      return newEntries;
    });

    setTimeout(() => {
      // wait until new row is rendered
      // const lastIndex = amountRefs.current.length - 1;
      const lastIndex = amountRefs.current.length;
      amountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
    // amountRefs.current[index + 1]?.focus();
  };

  const onDataToRecieve = (data) => {
    const transferType = selectedVoucherType?.startsWith("PV") ? "D" : "C";
    const newEntries = data.map((item) => ({
      account: selectedVoucherAccount?.ACCOUNT || "",
      description: selectedVoucherAccount?.DESCRIPTION || "",
      INV: item.INV || "",
      DESCR: item.DESCR || "",
      ty: transferType,
      AMOUNT: item.AMOUNT || 0,
      CUR: item.CUR || "",
      rate: item.rate || 1,
      FCBalAmt: item.BALAMT || 0,
      chqNo: "",
      chqDate: "",
      Bank: "",
      pdcAcc: "",
      x: "",
      JOBCODE: item.JOBCODE || "",
      vatAmt: "",
      total: "",
      trn: "",
    }));
    setEntries((prev) => [...prev, ...newEntries]);
    setIsChecked(false);
  };

  const types = [
    { name: "All", icon: Home },
    { name: "Cash", icon: DollarSign },
    { name: "Bank", icon: Landmark },
    { name: "PDC", icon: TicketCheck },
    { name: "Customers", icon: Users },
    { name: "Suppliers", icon: Package },
    { name: "Assets", icon: Briefcase },
    { name: "Liabilities", icon: CreditCard },
    { name: "Income", icon: TrendingUp },
    { name: "Expenses", icon: TrendingDown },
    { name: "InExpenses", icon: HandCoins },
    { name: "InterCompany", icon: Building2, disable: false },
  ];

  const formatBalance = (balance) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);

  const totalDebit = entries.reduce(
    (sum, row) => sum + (row?.ty === "D" ? Number(row.AMOUNT) || 0 : 0),
    0,
  );
  const totalCredit = entries.reduce(
    (sum, row) =>
      sum + (row?.ty === "C" ? Number(row.amount ?? row.AMOUNT) || 0 : 0),
    0,
  );
  const totalAmount = entries.reduce((sum, row) => {
    const baseAmt = Number(row?.AMOUNT || 0);
    const vatAmt = row?.vatOn ? (baseAmt * (USER?.vatp || 0)) / 100 : 0;
    return sum + baseAmt + vatAmt;
  }, 0);

  //   const totalCredit = entries.reduce(
  //   (sum, row) => sum + (row.ty === "C" ? Number(row.amount ?? row.AMOUNT || 0) : 0),
  //   0
  // );

  useEffect(() => {
    setSumOfAmount(Number(totalAmount.toFixed(2)));
    setPCAmount(Number(totalAmount.toFixed(2)));
    setSumOfDebit(Number(totalDebit.toFixed(2)));
    setSumOfCredit(Number(totalCredit.toFixed(2)));
    console.log("Entries:", entries);
    console.log(
      "Entries:",
      entries.filter((entry) => entry?.selected),
    );

    // console.log(
    //   "Total Debit:",
    //   totalDebit.toFixed(2),
    //   "Total Credit:",
    //   totalCredit.toFixed(2)
    // );
  }, [entries]);

  const handleVatToggle = (index, checked) => {
    const updatedEntries = [...entries];
    updatedEntries[index].vatOn = checked;
    setEntries(updatedEntries);
  };

  const handleDropdownSelectAccount = (rowIndex, acc) => {
    setSelectedVoucherAccount(acc);
    handleChange(rowIndex, "account", acc?.ACCOUNT);
    handleChange(rowIndex, "description", acc?.DESCRIPTION);
    setDropdownOpenIndex(null);
    setHighlightedIndex(-1);
    invRefs.current[rowIndex]?.focus(); // focus reference input

    setSelectedAccountsState((prev) => {
      const updated = [...prev];
      updated[rowIndex] = true;
      return updated;
    });
  };

  useEffect(() => {
    console.log("selectedAccountsState:", selectedAccountsState);
    const isCorrectAcclen = entries.some(
      (entry) => entry?.account.length === 8,
    );

    setIsCorrectLength(isCorrectAcclen);
    console.log("🚀 ~ Voucher ~ isAccountNotlength:", isCorrectAcclen);
    const currentEntries = entries.map((entry) => entry?.account);
    console.log("🚀 ~ Voucher ~ currentEntries:", currentEntries);

    // isCommentEmpty
    console.log("🚀 ~ Voucher ~ isCommentEmpty:", isCommentEmpty);
    // isCreditZero
    console.log("🚀 ~ Voucher ~ isCreditZero:", isCreditZero);
    // isDebitZero
    console.log("🚀 ~ Voucher ~ isDebitZero:", isDebitZero);
    // isDifferenceZero
    console.log("🚀 ~ Voucher ~ isDifferenceZero:", isDifferenceZero);
    // isAnyAccountEmpty
    console.log("🚀 ~ Voucher ~ isAnyAccountEmpty:", isAnyAccountEmpty);
    // isAnyAccountLength
    console.log("🚀 ~ Voucher ~ isAnyAccountLength:", isAnyAccountLength);
  }, [selectedAccountsState]);

  const requestCurrencyList = async ({ url, method, timeout }) => {
    return axios({
      url,
      method,
      timeout,
    }).then((res) => res.data);
  };

  const fetchCurrencyList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;

    try {
      const response = await requestCurrencyList({
        url: url,
        method: "GET",
        timeout: 10000,
      });

      // console.log("Response", response);
      setCurrencies(response || []);

      // Default currency from the fetched data
      if (response && response.length > 0) {
        // const defaultCurrency = response[0];
        const defaultCurrency = response.find((item) => item.rate === 1);
        // console.log("🚀 ~ fetchCurrencyList ~ defaultCurrency:", defaultCurrency)

        setSelectedCurrency(defaultCurrency);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setCurrencies([]);
    }
  };

  // useEffect(() => {
  //   setSelectedCurrencyRate(selectedCurrency?.rate?.toFixed(6));
  // }, [selectedCurrency]);

  // setFinalAmount(e.target.value)

  const handleDropdownSelectPdcAccount = (index, selectedAcc) => {
    handleChangePdcAcc(index, "pdcAcc", selectedAcc?.ACCOUNT || "");
    setPdcDropdownOpenIndex(null);
  };

  // filteredPDCAccounts
  // console.log("🚀 ~ Voucher ~ filteredPDCAccounts:", filteredPDCAccounts);

  const onRecurringJournal = () => {
    setRecurringJournal((prev) => !prev);
  };

  const cleanDate = (date) => {
    if (!date) return null;
    if (date.startsWith("1900") || date.includes("1900-01-01")) return null;
    return date.split("T")[0].split(" ")[0];
  };

  const onSaveVoucher = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;
    // const salesman_from_local_storage =  currentUser_from_local_storage?.sales_man

    const buildJVPayload = () => {
      let currentUser_from_local_storage = localStorage.getItem("currentUser")
        ? localStorage.getItem("currentUser")
        : "-";

      const user_from_local_storage = JSON.parse(
        localStorage.getItem("currentUser") || "[]",
      )[0]?.user;
      console.log(user_from_local_storage); // "ADMIN"

      const debitEntries = entries.map((row) => ({
        cmpcode: company_code_from_local_storage,

        operation: "ENTRY",
        JVTYPE: selectedVoucherType || "",
        TYPE_NO: pvnoFromAPI || "0",
        JVDATE: jvDate || null,
        CUST_ACC: row.account.trim() || "0",
        ACCDESC: row.description.trim() || "",
        AMOUNT: String(row.AMOUNT?.toFixed(2)) || "0",
        DESCRIPT: row.DESCR || "",
        // DEPTNO: currentSelectedDepartment_from_local_storage || "",
        DEPTNO: DEPARTMENT,
        COMMENTS: comment || "",
        USERID: user_from_local_storage?.trim() || "",
        job_code: row.JOBCODE || "",
        sman_code: "",
        costc: row.costCode || "",
        chqno: row.chqNo || "",
        chqdate: row.chqDate || null,
        // rate: row.rate + "" || "1",
        rate: row.rate || "1",
        pdcstatus: "",

        pdc_acc: row.pdcAcc || "0",
        reason: "",
        account: row.account.trim() || "0",
        jvnum: pvnoFromAPI || "0",
        ref: row.INV || "0",
        entry_ref: row.DESCR || "",
        type: "D",
        curno: row.curno || "AED",
        curamount: row?.curamount || row?.FCBalAmt,
        user_id: user_from_local_storage?.trim() || "",
        accountype: row.ty || "",
        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: row.Bank || "",
        due_date: null,
        doc_date: null,
        // doc_date:
        //   generatedEntriesState?.length > 0
        //     ? row.docDate
        //     : jvRecurringDate || null,

        month: "1",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: row.CCENTER || "",
        ttref: row.trn || "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: recurringJournal ? "R" : "",
        upd: "",
        v_amt: row.vatOn ? Number(row.AMOUNT * 0.05).toFixed(2) : "0",
        COSTCODE: row.vatOn ? "VAT" : "",
      }));

      const creditEntry = {
        cmpcode: company_code_from_local_storage,
        operation: "ENTRY",
        JVTYPE: selectedVoucherType || "",
        TYPE_NO: pvnoFromAPI || "0",
        JVDATE: jvDate || null,
        CUST_ACC: selectedAccount || "0",
        ACCDESC: selectedAccountDesc.trim() || "",
        AMOUNT: String(pcAmount.toFixed(2)) || "0",
        DESCRIPT: comment || "",
        DEPTNO: DEPARTMENT,
        COMMENTS: comment || "",
        USERID: user_from_local_storage?.trim() || "",
        job_code: jobCode || "",

        sman_code: "",
        costc: "",
        chqno: "",
        chqdate: null,
        rate: "1",
        pdcstatus: "",
        pdc_acc: "0",
        reason: "",
        account: selectedAccount || "0",
        jvnum: pvnoFromAPI || "0",
        ref: "",
        entry_ref: comment,
        type: "C",
        curno: "AED",
        curamount: "0",
        user_id: user_from_local_storage?.trim() || "",
        accountype: "0",

        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: "",
        due_date: null,
        doc_date: null,

        month: "2",
        lpono: "",
        chqprn: "0",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: "",
        ttref: "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: "0",
        COSTCODE: "",
      };

      return [creditEntry, ...debitEntries];
    };

    const finalJVload = buildJVPayload();
    console.log("finalJVload", finalJVload);
    // return;

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMRVPVReg`;
    try {
      const response = await axios.post(apiUrl, finalJVload, config);

      console.log("Receipt data Saved:", response.data);
      const data = response?.data;
      setSavedVNO(data?.vno);

      // setReceiptSavedPopup(true);

      setOpenSavePopup(true);
      // setOpenSnackbar(true);
      setEntries(initialVoucherEntries);
    } catch (error) {
      console.log("error while saving reciept", error);
      setOpenErrorSnackbar(true);
    }
  };
  const onModifyVoucher = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;
    // const salesman_from_local_storage =  currentUser_from_local_storage?.sales_man

    const buildJVPayload = () => {
      let currentUser_from_local_storage = localStorage.getItem("currentUser")
        ? localStorage.getItem("currentUser")
        : "-";

      const user_from_local_storage = JSON.parse(
        localStorage.getItem("currentUser") || "[]",
      )[0]?.user;
      // console.log(user_from_local_storage); // "ADMIN"

      const journalVoucherEntry = entries.map((row) => ({
        // row.chqdate
        // console.log(row.chqdate)
        cmpcode: company_code_from_local_storage,

        operation: "EDIT",
        JVTYPE: selectedVoucherType || "",
        TYPE_NO: pvnoFromAPI || "0",
        JVDATE: jvDate || null,
        CUST_ACC: row.account.trim() || "0",
        ACCDESC: row.accdesc || "",
        AMOUNT: row.amount + "" || "0",
        DESCRIPT: row.DESCR || "",
        // DEPTNO: currentSelectedDepartment_from_local_storage || "",
        DEPTNO: DEPARTMENT,
        COMMENTS: comment || "",
        USERID: user_from_local_storage?.trim() || "",
        job_code: row.job_code || "",
        sman_code: "",
        costc: row.COSTCODE || "",
        chqno: row.chqno || "",
        // chqdate: row.chqdate || null,
        chqdate: cleanDate(row.chqdate),
        rate: row.rate + "" || "1",
        pdcstatus: "",
        pdc_acc: row.pdc_acc || "0",
        reason: "",
        account: row.account.trim() || "0",
        jvnum: pvnoFromAPI || "0",
        ref: row.ref || "",
        entry_ref: row.DESCR || "",
        type: row.type || "",
        curno: row.curno || "AED",
        curamount: row?.curamount || row?.FCBalAmt,
        user_id: user_from_local_storage?.trim() || "",
        // accountype: row.type || "",
        accountype: row.ty === "D" ? "1" : "2" || "0",
        depn_p: "0",
        status1: "",
        status: row.vatOn ? "V" : "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: row.bank || "",
        due_date: null,
        // doc_date: row.reccurringDate || null,
        // doc_date: jvRecurringDate || null,
        doc_date:
          generatedEntriesState?.length > 0
            ? row.docDate
            : jvRecurringDate || null,

        month: row.ty === "D" ? "1" : "2" || "0",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: row.ccno || "",
        ttref: row.ttref || "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: row.vatOn
          ? ((Number(row.amount) * USER.vatp) / 100).toFixed(2)
          : "0",
        COSTCODE: row.vatOn ? "VAT" : "",
      }));

      return journalVoucherEntry;
    };

    const finalJVload = buildJVPayload();

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMRVPVReg`;
    try {
      const response = await axios.post(apiUrl, finalJVload, config);

      console.log("Voucher data Modified:", response.data);
      const data = response?.data;
      setModifiedVNO(data?.vno);
      // setReceiptSavedPopup(true);
      // setOpenSavePopup(true);

      setOpenModifiedPopup(true);
      fetchVoucherTimeline(pvnoFromAPI);
      // setOpenSnackbar(true);
    } catch (error) {
      console.log("error while saving reciept", error);
      setOpenErrorModifySnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSavePopup(false);
    setOpenModifiedPopup(false);

    setOpenErrorSnackbar(false);
    setOpenErrorModifySnackbar(false);
    // setOpenSnackbar(false);

    window.location.reload();
  };

  const fullHistoryOfStatusChange = [
    {
      create_date: new Date(2025, 9, 10, 10, 15),
      status: "Pending Approval",
      Comments: "Voucher submitted for review",
    },
    {
      create_date: new Date(2025, 9, 11, 14, 30),
      status: "Approved",
      Comments: " Voucher Approved",
    },
    {
      create_date: new Date(2025, 9, 12, 9, 45),
      status: "In Progress",
      Comments: "Work has started on the approved voucher",
    },
    {
      create_date: new Date(2025, 9, 13, 17, 10),
      status: "Completed",
      Comments: "Voucher successfully completed",
    },
  ];

  // const onModify = () => {
  //   setPdcDropdownOpenIndex(null);
  //   setModifyPopup(true);
  // };

  useEffect(() => {
    // selectedPlan
    console.log("🚀 ~ Voucher ~ selectedPlan:", selectedPlan);

    console.log("🚀 ~ Voucher ~ entries:", entries);
  }, [selectedPlan]);

  const onGenerate = () => {
    console.log("Generate clicked");
    console.log("frequency:", frequency);
    console.log("jvRecurringDate:", jvRecurringDate);
    console.log("plan:", selectedPlan);
    console.log("entries:", entries);

    let repeatCount = 1;

    if (selectedPlan === "daily") repeatCount = Number(frequency);
    else if (selectedPlan === "monthly") repeatCount = Number(frequency);
    else if (selectedPlan === "yearly") repeatCount = Number(frequency);
    else repeatCount = Number(frequency) || 1;

    const generatedEntries = Array.from({ length: repeatCount }, (_, i) =>
      entries.map((entry) => {
        const rawDate =
          selectedPlan === "daily"
            ? new Date(
              new Date(jvRecurringDate).setDate(
                new Date(jvRecurringDate).getDate() + i,
              ),
            )
            : selectedPlan === "monthly"
              ? new Date(
                new Date(jvRecurringDate).setMonth(
                  new Date(jvRecurringDate).getMonth() + i,
                ),
              )
              : selectedPlan === "yearly"
                ? new Date(
                  new Date(jvRecurringDate).setFullYear(
                    new Date(jvRecurringDate).getFullYear() + i,
                  ),
                )
                : new Date(jvRecurringDate);

        // Format as DD/MM/YYYY
        // const formattedDate = rawDate.toLocaleDateString("en-GB");
        const formattedDate = rawDate.toISOString().split("T")[0]; // YYYY-MM-DD

        return {
          ...entry,
          docDate: formattedDate,
        };
      }),
    ).flat();

    console.log("Generated entries:", generatedEntries);
    setGeneratedEntriesState(generatedEntries);
    setEntries(generatedEntries);
    setSelectedAccountsState(Array(generatedEntries.length).fill(true));
    setDisableGenerate(true);
  };

  const onNew = () => {
    // modifyVoucherNoFromView('')
    setPdcDropdownOpenIndex(null);
    // setModifyPopup(true);
    setModifyButton(false);
    setEntries(initialVoucherEntries);
    setPVnoFromAPI("");
    // handleVoucherTypeChange('JV')
    fetchVoucherNo();
    // window.location.reload();
    // navigate("/voucher", { replace: true });
    navigate("/voucher");
  };
  const onDelete = () => {
    setPdcDropdownOpenIndex(null);
    // window.location.reload();
    setDeletePopup(true);
  };

  const onSubmitVoucherDeleteNo = async (deleteVoucherNo) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
  };

  // const onModifyClose = () => {
  //   setModifyPopup(false);
  // };

  const navigate = useNavigate();

  const onSubmitVoucherModifyNo = (newVNO) => {
    setModifyPopup(false);
    setPVnoFromAPI(newVNO);
    // setModifyVoucherNo("")
    // setModifyVoucherPage(true);
    fetchModifyVNoData(newVNO);
    setModifyButton(true);
  };

  const fetchModifyVNoData = async (newVNO) => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiURL = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${COMPANY_CODE}/VOUCHERMODIFY/${selectedVoucherType}/-/-/${DEPARTMENT}/${newVNO}/-`;

    try {
      const response = await axios.get(apiURL);
      const apiData = response.data;

      // Map API fields to expected format
      const mappedData = apiData.map((row) => ({
        ...row,
        INV: row.ref || row.INV || "", // Ensure INV has the ref value
        DESCR: row.DESCR || row.entry_ref || row.description || "",
        AMOUNT: row.AMOUNT || row.amount || 0,
        ty: row.type || row.accountype || row.ty || "D",
        account: row.account || row.CUST_ACC || "",
        description: row.ACCDESC || row.description || "",
        // Add other mappings as needed
        chqNo: row.chqno || row.chqNo || "",
        chqDate: row.chqdate || row.chqDate || "",
        JOBCODE: row.job_code || row.JOBCODE || "",
        // ... map all other fields
      }));

      console.log("🚀 Mapped Data:", mappedData);
      console.log("🚀 Voucher number changed data :", mappedData);
      const isRecurInModData = mappedData.some((data) => data.pgroup === "R");
      setIsRecurringInModifyData(isRecurInModData);
      setEntries(mappedData);
      // setModifyButton(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    console.log("🚀 ~ Voucher ~ modifyVoucherNo:", modifyVoucherNo);
  }, [modifyVoucherNo]);

  const getTooltipMessage = () => {
    if (isCommentEmpty && !isDifferenceZero)
      return "Add a comment and ensure credit and debit are balanced.";
    if (isCommentEmpty) return "Please enter comments before saving.";
    if (!isDifferenceZero) return "Difference must be 0 before saving.";
    return "";
  };

  const onVoucherView = () => {
    navigate("/pettyCashView");
  };

  // const handleCurrencyChange = (index, value) => {
  //   const selected = currencies.find((cur) => cur.curno === value);
  //   setSelectedCurrencyRate(selected.rate);
  //   // console.log("🚀 ~ handleCurrencyChange ~ selected:", selected);

  //   setEntries((prev) => {
  //     const updated = [...prev];
  //     updated[index] = {
  //       ...updated[index],
  //       curno: selected.curno,
  //       rate: selected.rate,
  //     };
  //     return updated;
  //   });
  // };

  const handleCurrencyChange = (index, value) => {
    const selected = currencies.find((cur) => cur.curno === value);
    const rate = parseFloat(selected?.rate) || 1;

    setEntries((prev) => {
      const updated = [...prev];
      const current = updated[index];

      const amount = parseFloat(current.AMOUNT) || 0;
      const fcBalAmt = parseFloat(current.FCBalAmt) || 0;

      updated[index] = {
        ...current,
        curno: selected.curno,
        rate,
        AMOUNT: amount
          ? Number(amount).toFixed(2)
          : Number(fcBalAmt * rate).toFixed(2),
        FCBalAmt: fcBalAmt
          ? Number(fcBalAmt).toFixed(2)
          : Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  //   const handleCurrencyChange = (index, value) => {
  //   const selected = currencies.find((cur) => cur.curno === value);
  //   if (!selected) return;

  //   const rate = parseFloat(selected.rate) || 1;

  //   setEntries((prev) => {
  //     const updated = [...prev];
  //     const currentAmount = parseFloat(updated[index].AMOUNT || updated[index].amount || 0);

  //     updated[index] = {
  //       ...updated[index],
  //       curno: selected.curno,
  //       rate: rate,
  //       FCBalAmt: (currentAmount / rate).toFixed(2), // ✅ update foreign amount
  //     };

  //     return updated;
  //   });

  //   // Update global selected rate state (if you’re using it elsewhere)
  //   setSelectedCurrencyRate(rate);
  // };

  const handleVoucherTypeChange = (mod) => {
    const value = mod;
    const selectedVoucher = voucherTypeList.find(
      (voucher) => voucher.VTYPE === value,
    );

    setSelectedVoucherType(value);
    setSelectedVoucherDescription(selectedVoucher?.VDESCRIPTION || "");
  };

  useEffect(() => {
    if (setupBillAccount) {
      console.log("🚀 ~ Voucher ~ setupBillAccount:", setupBillAccount);

      setIsAccountFocused(true);
    }
  }, [setupBillAccount]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (
      //   accountContainerRef.current &&
      //   !accountContainerRef.current.contains(event.target) &&
      //   !setupBillContainerRef.current.contains(event.target)
      // ) {
      //   setSetupBillAccount("");
      //   setIsAccountFocused(false);
      // }
      if (
        accountRowContainerRef.current &&
        !accountRowContainerRef.current?.contains(event.target) &&
        !setupBillContainerRef.current?.contains(event.target)
      ) {
        setSetupBillAccount("");
        setIsAccountFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (frequency.length > 0) {
      setDisableGenerate(false);
    } else {
      // setDisableGenerate(true);
    }
  }, [frequency]);

  const handleVoucherChange = (direction) => {
    setRecurringJournal(false);

    if (!pvnoFromAPI) return;

    const currentNo = Number(pvnoFromAPI) || 0;
    // Assuming maxVoucherNo is available or passed as a prop/state
    const maxNo = Number(maxVoucherNo) || currentNo; // Use actual max voucher number
    let newNo = currentNo;

    if (direction === "next") {
      if (currentNo < maxNo) {
        newNo = currentNo + 1;
      } else {
        return; // At latest voucher
      }
    } else if (direction === "prev") {
      if (currentNo > 1) {
        newNo = currentNo - 1;
      } else {
        return; // At first voucher
      }
    } else {
      return; // Invalid direction
    }

    setPVnoFromAPI(String(newNo));
    fetchModifyVNoData(newNo);
    fetchVoucherTimeline(newNo);
  };

  useEffect(() => {
    fetchJobCodeList();
    const handleKeyDown = (e) => {
      // Check if Alt + A is pressed
      if (e.altKey && e.key.toLowerCase() === "a") {
        e.preventDefault();
        console.log(" Alt/Option + A pressed!");
        handleAddRow();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const fetchJobCodeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/JOBLIST/-/-`;

    try {
      const response = await axios.get(apiURL);
      const data = response.data;
      setJobCodeList(data || []);
    } catch (err) {
      console.error("Error while fetching job code list", err);
    }
  };

  const handleCustomerSelect = (data) => {
    setSelectedAccount(data.ACCOUNT);
    setSelectedAccountDesc(data.DESCRIPTION);
    setSelectedAccountBal(data.BALANCE);
    console.log("data:", data);
    setCrPCModalOpen(false);
  };

  const handleDrCustomerSelect = (data) => {
    // setSelectedAccount(data.ACCOUNT);
    // setSelectedAccountDesc(data.DESCRIPTION);
    // setSelectedAccountBal(data.BALANCE);
    console.log("data from voucher list:", data);

    handleDropdownSelectAccount(selectedRowIndex, data);
    setDrPCModalOpen(false);
  };

  return (
    <>
      {/* {modifyVoucherPage ? (
        <ModifyVoucher modifyVoucherNo={modifyVoucherNo} />
      ) : ( */}
      <div className="p-2 ">
        <div className="flex items-center justify-between  ">
          <h2 className="text-xl text-gray-800 mb-4">Petty Cash</h2>
          <button
            onClick={onVoucherView}
            className="relative ml-4 bg-blue-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[0.8em] flex items-center overflow-hidden cursor-pointer   group"
          >
            <span className="mr-8">View</span>
            <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.6em] rounded-[0.8em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
              <FaEye className=" text-blue-600 " />
            </div>
          </button>
        </div>

        <div className="shadow-sm border border-gray-200 rounded-md pt-4 px-6  bg-white max-w-7xl mx-auto">
          <div className="flex justify-between ">
            <div></div>

            <div className="flex">
              {/* {modifyButton ? (
                <div className="flex justify-center items-center gap-2 h-full">
                  <div className="bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] ">
                    <button
                      // disabled={disableModify}
                      onClick={onNew}
                      className={`group p-[2px] rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995]`}
                    >
                      <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                        <div className="flex gap-2 items-center">
                          <Plus className="w-3 h-4" />
                          <span className="font-semibold text-sm">New</span>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div className="bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] ">
                    <button
                      // disabled={disableModify}
                      // onClick={onDelete}
                      onClick={() => setShowDeleteConfirm(true)}
                      className={`group p-[2px] rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995]`}
                    >
                      <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                        <div className="flex gap-2 items-center">
                          <Trash2 className="w-3 h-4" />
                          <span className="font-semibold text-sm">Delete</span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center gap-12 h-full">
                  <div className="bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] ">
                    <button
                      disabled={disableModify}
                      onClick={onModify}
                      className={`group p-[2px] rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995] 
    ${
      disableModify
        ? "bg-gray-200 cursor-not-allowed opacity-60"
        : "bg-gradient-to-b from-white to-stone-200/40 hover:bg-gray-400"
    }`}
                    >
                      <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                        <div className="flex gap-2 items-center">
                          <Edit3 className="w-3 h-4" />
                          <span className="font-semibold text-sm">Modify</span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              )} */}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6 ">
            <div className="">
              <div className="flex justify-between items-center mb-4 ">
                <div className="w-20">
                  <label className="block text-sm font-medium mb-1">
                    PC No
                  </label>
                  <div className="flex items-center gap-2 justify-center">
                    {/* Previous Button */}
                    {/* <button
                    type="button"
                    onClick={() => handleVoucherChange("prev")}
                    className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                  >
                    <ChevronLeft className="w-4 h-4 text-gray-700" />
                  </button> */}

                    {/* Voucher Display */}
                    <input
                      type="text"
                      value={pvnoFromAPI}
                      readOnly
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-gray-100 text-center"
                    />

                    {/* Next Button */}
                    {/* <button
                    type="button"
                    onClick={() => handleVoucherChange("next")}
                    className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                  >
                    <ChevronRight className="w-4 h-4 text-gray-700" />
                  </button> */}

                    {/* <button
                    type="button"
                    onClick={() => handleVoucherChange("next")}
                    disabled={Number(pvnoFromAPI) >= Number(pvnoFromAPI + 1)}
                    className={`p-2 rounded-md transition ${
                      !Number(pvnoFromAPI + 1) ||
                      Number(pvnoFromAPI + 1) > Number(pvnoFromAPI)
                        ? "bg-gray-100 cursor-not-allowed"
                        : "bg-gray-200 hover:bg-gray-300"
                    }`}
                  >
                    <ChevronRight className="w-4 h-4 text-gray-700" />
                  </button> */}
                  </div>
                </div>
                <div className="">
                  <label className="block text-sm font-medium mb-1">Date</label>
                  <input
                    type="date"
                    value={jvDate}
                    onChange={(e) => setJvDate(e.target.value)}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-gray-100"
                  />
                </div>
                <div className="w-28">
                  <label className="block text-sm font-medium mb-1">
                    Amount
                  </label>
                  <div className="flex items-right gap-2 justify-center">
                    {/* Previous Button */}
                    {/* <button
                    type="button"
                    onClick={() => handleVoucherChange("prev")}
                    className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                  >
                    <ChevronLeft className="w-4 h-4 text-gray-700" />
                  </button> */}

                    {/* Voucher Display */}
                    <input
                      type="number"
                      // value={pcAmount.toFixed(2)}
                      value={sumOfAmount.toFixed(2)}
                      onClick={(e) => e.target.select()}
                      onChange={(e) =>
                        setPCAmount(parseFloat(e.target.value) || 0)
                      }
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded bg-gray-100 text-right"
                    />
                  </div>
                </div>
                <div className="w-28">
                  <label className="block text-sm mb-1 flex items-center">
                    Job Code
                  </label>
                  <select
                    value={jobCode}
                    onChange={(e) => {
                      const selectedDept = jobCodeList.find(
                        (dept) => dept.deptno === e.target.value,
                      );
                      setJobCode(e.target.value);
                      // setDeptDesc(
                      //   selectedDept ? selectedDept.deptnodesc : ""
                      // );
                    }}
                    className="w-full px-4 py-2 text-sm rounded bg-gray-100 border border-gray-300"
                  >
                    <option value="all">ALL</option>
                    {jobCodeList.map((job, index) => (
                      <option key={index} value={job.JobCode}>
                        {job.JobCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="flex justify-between items-end mb-4 gap-2">
                <div className="flex-1 ">
                  <label className="block text-sm font-medium mb-1">Cr</label>
                  <div className="flex gap-2">
                    <Tooltip
                      title={selectedAccount.length > 0 ? "" : "Press F2"}
                      arrow
                    >
                      <div className="w-32">
                        <input
                          ref={crInputRef}
                          onKeyDown={(e) => {
                            if (e.key === "F2") {
                              fetchAccountList("CASH");
                              // setSelectedRowIndex(index);
                              setCrPCModalOpen(true);
                              // setDropdownOpenIndex(null);
                            }
                          }}
                          // type="text"
                          value={selectedAccount}
                          // readOnly
                          placeholder="Select Account"
                          className={`w-full px-3 text-sm border border-gray-300 rounded bg-gray-100 text-left ${selectedAccount.length > 0 ? "py-2" : "py-1.5"
                            }`}
                        />
                      </div>
                    </Tooltip>

                    <div className="flex-1 w-full">
                      <div className="flex items-center justify-between w-full px-3 py-1.5 border border-gray-300 rounded bg-gray-100">
                        <span className="text-sm text-gray-900 truncate">
                          {selectedAccountDesc || "No account selected"}
                        </span>

                        {selectedAccountBal && (
                          <span
                            className={`ml-2 text-xs px-2 py-1 rounded-full shadow-sm bg-white font-medium ${selectedAccountBal < 0
                              ? "text-red-600"
                              : "text-green-600"
                              } `}
                          >
                            {selectedAccountBal}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="flex justify-between items-center">
                  <label className="block text-sm font-medium mb-1">
                    Description <span className="text-red-600">*</span>
                  </label>
                </div>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Enter description..."
                  className="p-2 rounded-lg bg-gray-100 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 w-full h-[85px]"
                  rows={4}
                />
              </div>
            </div>
            <div className="">
              <label className="block text-sm font-medium mb-1">
                PC Timeline
              </label>
              <div
                className="bg-[#F3F4F6]  rounded border border-gray-300"
                style={{
                  height: "260px",
                  overflowY: "scroll",
                  padding: "6px",
                  // marginRight: "10px",
                }}
              >
                {voucherTimeLineList ? (
                  voucherTimeLineList.length > 0 ? (
                    voucherTimeLineList?.map((item) => {
                      return (
                        <div className=" bg-white border rounded shadow p-1 m-2">
                          <p className="flex">
                            <div>
                              <img src={ic_timeline_circle_indicator} />
                            </div>
                            <div className="ms-2  w-full">
                              <div className="flex justify-between items-center">
                                {/* <div> */}
                                <span className="text-xs font-semibold">
                                  {format(item.create_date, "dd-MM-yyyy")}{" "}
                                </span>
                                <span
                                  className="text-xs font-semibold"
                                  style={{ marginLeft: "5px" }}
                                >
                                  {format(item.create_date, "hh:mm a")}{" "}
                                </span>
                                <span
                                  className="text-xs font-semibold"
                                  style={{ marginLeft: "5px" }}
                                >
                                  User: {item.userid}
                                </span>
                                {/* </div> */}
                                <div className="px-1">
                                  <span className="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-1.5 py-0.5 rounded dark:bg-gray-700 dark:text-white">
                                    {" "}
                                    {item.status}{" "}
                                  </span>
                                </div>
                              </div>
                              {/* <div> */}
                              {/* <span>{item.Comments}</span> */}
                              {/* </div> */}
                            </div>
                          </p>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img style={{ width: "90px" }} src={ic_no_data} />
                      <p className="p-2 text-slate-500">
                        {" "}
                        No data in PC timeline
                      </p>
                    </div>
                  )
                ) : (
                  <p>
                    Unable to fetch voucher timeline, please contact support
                    team.
                  </p>
                )}
              </div>
              <div className="flex justify-between items-end my-4  gap-4">

              </div>
            </div>
          </div>
        </div>

        {pvnoFromAPI ? (
          <>
            {/* {modifyVoucherPage ? (
               <ModifyVoucher modifyVoucherNo={modifyVoucherNo} />
             ) : ( */}
            <div className="max-w-7xl mx-auto mb-4">
              <div className="mt-4 border rounded bg-white overflow-x-auto overflow-y-auto h-[28vh] mx-auto">
                <table className="min-w-full border-collapse text-sm max-h-600">
                  <thead className="bg-gray-100 sticky top-0 z-20">
                    <tr className="min-h-12">
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[40px]">
                        <input
                          type="checkbox"
                          className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                          checked={
                            entries.length > 0 &&
                            entries.every((e) => e?.selected)
                          }
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setEntries((prev) =>
                              prev.map((entry) => ({
                                ...entry,
                                selected: checked,
                              })),
                            );
                          }}
                        />
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
                        SL No.
                      </th>
                      {/* {(recurringJournal || isRecurringInModifyData) && (
                        <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                          Recurring Date
                        </th>
                      )} */}
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        Account
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[300px]">
                        Account Name
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        Reference
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[180px]">
                        Description
                      </th>
                      {/* <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
                        TY
                      </th> */}
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        Amount
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        VAT %
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        VatAmt
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        Total
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        TRN
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[50px]">
                        X
                      </th>


                    </tr>
                  </thead>
                  <tbody>
                    {entries?.map((row, index) => (
                      <tr
                        key={index}
                        className="max-h-12"
                        ref={accountRowContainerRef}
                        onClick={() => setSetupBillAccount(row.account)}
                      >
                        <td className="border px-2 py-1 text-center">
                          <input
                            type="checkbox"
                            checked={row?.selected || false}
                            className={` w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setEntries((prev) => {
                                const updated = [...prev];
                                updated[index].selected = checked;
                                return updated;
                              });
                            }}
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-center">
                          {index + 1}
                        </td>



                        <td className="border text-sm font-normal relative">
                          <div ref={accountContainerRef} className="relative">
                            <input
                              ref={(el) => (accountRefs.current[index] = el)}
                              // value={row?.account.trim()}
                              value={row?.account || ""}
                              onFocus={(e) => {
                                e.target.select();
                                setDropdownOpenIndex(index);
                                setSearchVoucherAccountTerm(row.account);
                                // setSetupBillAccount(row.account);
                              }}
                              onChange={(e) => {
                                handleChange(index, "account", e.target.value);
                                setDropdownOpenIndex(index);

                                setSelectedAccountsState((prev) => {
                                  const updated = [...prev];
                                  updated[index] = false;
                                  return updated;
                                });
                              }}
                              // onBlur={(e) => {
                              //   handleChange(
                              //     index,
                              //     "account",
                              //     e.target.value.trim()
                              //   );
                              // }}
                              onKeyDown={(e) => {
                                if (e.key === "F2") {
                                  fetchAccountList("CASH");
                                  setSelectedRowIndex(index);
                                  // setVoucherModalOpen(true);
                                  setDrPCModalOpen(true);
                                  setDropdownOpenIndex(null);
                                }

                                // ⬇ open dropdown and highlight first item
                                if (e.key === "ArrowDown") {
                                  e.preventDefault();
                                  setDropdownOpenIndex(index);
                                  setHighlightedIndex(0);
                                }

                                // Enter key (if dropdown not open)
                                if (
                                  e.key === "Enter" &&
                                  dropdownOpenIndex !== index
                                ) {
                                  e.preventDefault();
                                  accountNameRefs.current[index]?.focus();
                                }

                                // Navigate dropdown
                                if (
                                  dropdownOpenIndex === index &&
                                  filteredAccounts?.length > 0
                                ) {
                                  if (e.key === "ArrowUp") {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) =>
                                      prev > 0
                                        ? prev - 1
                                        : filteredAccounts.length - 1,
                                    );
                                  } else if (e.key === "ArrowDown") {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) =>
                                      prev < filteredAccounts.length - 1
                                        ? prev + 1
                                        : 0,
                                    );
                                  } else if (e.key === "Enter") {
                                    e.preventDefault();
                                    const selectedAcc =
                                      filteredAccounts[highlightedIndex];
                                    if (selectedAcc)
                                      // handleSelectAccount(index, selectedAcc);
                                      handleDropdownSelectAccount(
                                        index,
                                        selectedAcc,
                                      );
                                  } else if (e.key === "Escape") {
                                    setDropdownOpenIndex(null);
                                    setHighlightedIndex(-1);
                                  }
                                }
                              }}
                              className={`w-full px-2 py-1 m-0 text-sm border-none rounded focus:ring-1 focus:ring-blue-400
  ${row?.account && !selectedAccountsState[index]
                                  ? "bg-red-400"
                                  : "bg-transparent"
                                }`}
                            />

                            {dropdownOpenIndex === index && (
                              <div
                                ref={(el) =>
                                  (voucherDropdownRefs.current[index] = el)
                                }
                                className="absolute z-10 left-0 top-7 bg-white border border-gray-300 w-[300px] mt-1 max-h-40 shadow-lg overflow-y-auto rounded-md "
                              >
                                {filteredAccounts?.length > 0 ? (
                                  filteredAccounts.map((acc, i) => (
                                    <div
                                      key={i}
                                      onClick={() => {
                                        handleDropdownSelectAccount(index, acc);
                                      }}
                                      className={`px-1 py-2 text-sm flex items-center gap-4 cursor-pointer border-b border-gray-100 last:border-b-0 ${i === highlightedIndex
                                        ? "bg-blue-100 hover:bg-blue-200"
                                        : "hover:bg-gray-100"
                                        }`}
                                    >
                                      <div className="text-xs font-semibold text-white bg-blue-500 px-2 py-1 rounded-md">
                                        {acc.ACCOUNT}
                                      </div>
                                      <div className="font-thin text-gray-900 text-xs truncate max-w-[250px]">
                                        {acc.DESCRIPTION}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="w-[310px] p-3 flex flex-row items-center justify-start bg-[#F7C752] rounded-lg shadow-[0_0_5px_-3px_#111] font-sans">
                                    <div className="w-5 h-5 -translate-y-0.5 mr-2">
                                      <svg
                                        fill="none"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="m13 14h-2v-5h2zm0 4h-2v-2h2zm-12 3h22l-11-19z"
                                          fill="#393A37"
                                        ></path>
                                      </svg>
                                    </div>
                                    <div className="text-sm font-semi-bold text-[#393A37] italic">
                                      Account not available in list
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal">
                          <input
                            ref={(el) => (accountNameRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={row?.accdesc || row?.description}
                            onChange={(e) =>
                              handleChange(index, "accdesc", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                invRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        {/* <td className="border px-2 py-1 text-sm font-normal text-right">
                            <input
                              onFocus={(e) => {
                                e.target.select();
                              }}
                              ref={(el) => (invRefs.current[index] = el)}
                              value={row.ref || row.INV || ''}
                              onChange={(e) =>
                                handleChange(index, "INV", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  descriptionRefs.current[index]?.focus();
                                }
                              }}
                              className="w-full text-right px-2 py-1 text-sm border-none rounded"
                            />
                          </td> */}

                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            onFocus={(e) => e.target.select()}
                            ref={(el) => (invRefs.current[index] = el)}
                            value={row?.INV || row?.ref || ""} // Check both fields
                            onChange={(e) =>
                              handleChange(index, "INV", e.target.value)
                            } // Always update INV
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                descriptionRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>

                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (descriptionRefs.current[index] = el)}
                            value={row?.LPONO || row?.DESCR}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "DESCR", e.target.value)
                            }
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                tyRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                          />
                        </td>
                        {/* <td className="border px-2 py-1 text-sm font-normal text-right">
                          <button
                            ref={(el) => (tyRefs.current[index] = el)}
                            onClick={() => handleTyData(index)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                // Move focus to next row's first cell (Description input for example)
                                amountRefs.current[index]?.focus();
                              } else if (e.key === " ") {
                                e.preventDefault(); // prevent page scroll when pressing space
                                handleTyData(index); // toggle value on spacebar
                              }
                            }}
                            className={`w-full text-center px-2 py-1 text-sm rounded ${
                              // (ty[index] || row.ty) === "D"
                              (row?.type || row?.ty) === "D"
                                ? "bg-green-400"
                                : "bg-red-400"
                            }`}
                          >
                            {/* {ty[index] || row.ty} 
                            {row?.type || row?.ty}
                          </button>
                        </td> */}
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (amountRefs.current[index] = el)}
                            value={row?.amount ?? row?.AMOUNT ?? ""}
                            onClick={(e) => e.target.select()}
                            onChange={(e) => {
                              const handler = !modifyButton
                                ? handleChangeAmountEntry
                                : handleChangeAmountModify;
                              handler(index, "AMOUNT", e.target.value);
                            }}
                            onFocus={(e) => e.target.select()}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                curRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>

                        <td className="border px-2 py-1 text-sm text-right">
                          <div className="flex justify-between items-center">
                            <label className="text-md font-semibold mr-2">
                              {row?.vatOn ? USER.vatp : "0"}
                            </label>
                            <div className="flex items-center gap-2">
                              <label className="relative inline-block w-[3.5em] h-[2em]">
                                <input
                                  type="checkbox"
                                  ref={(el) => (isVatRefs.current[index] = el)}
                                  className="peer sr-only"
                                  checked={row?.vatOn || false}
                                  onChange={(e) =>
                                    handleVatToggle(index, e.target.checked)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === " ") {
                                      e.preventDefault(); // prevent page scroll
                                      handleVatToggle(index, !row?.vatOn); // toggle ON/OFF
                                    } else if (e.key === "Enter") {
                                      e.preventDefault();
                                      // move focus to next row toggle if exists
                                      handleAddRow();
                                    }
                                  }}
                                />

                                <span
                                  className="
      absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
      after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
      after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
      after:transition-all after:duration-300 after:ease-in-out
      after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
      peer-checked:bg-blue-500
      peer-checked:after:translate-x-[1.5em]
      peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
      peer-active:after:w-[3em]
      peer-checked:peer-active:after:translate-x-[0.5em]
    "
                                ></span>
                              </label>
                            </div>
                          </div>
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (vatAmtRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={
                              row?.v_amt || row.vatOn
                                ? (
                                  (Number(row?.amount ?? row?.AMOUNT) * (USER.vatp || 0)) /
                                  100
                                ).toFixed(2)
                                : ""
                            }
                            onChange={(e) =>
                              handleChange(index, "vatAmt", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline

                                totalRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (totalRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={
                              row?.vatOn
                                ? Number(row?.amount ?? row?.AMOUNT) +
                                Number(row?.amount ?? row?.AMOUNT) * (USER?.vatp || 0) / 100
                                : Number(row?.amount ?? row?.AMOUNT)
                            }
                            onChange={(e) =>
                              handleChange(index, "total", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();

                                trnRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (trnRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={row?.ttref || row?.trn}
                            onChange={(e) =>
                              handleChange(index, "trn", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                isVatRefs.current[index]?.focus();
                                // trnRefs.current[index+1]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (xRefs.current[index] = el)}
                            value={row?.x}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                jobCodeRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            onChange={(e) =>
                              handleChange(index, "x", e.target.value)
                            }
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="z-[10] flex border justify-between p-3 border-t sticky bottom-0 bg-gray-100 w-full text-sm font-medium">
                {/* <div className="flex items-center justify-between gap-16 text-sm font-medium"> */}
                <div className="flex justify-center items-center gap-2">
                  <button
                    onClick={handleAddRow}
                    // className="px-3 py-1 text-sm border rounded bg-gray-50 hover:bg-gray-100"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition flex justify-center items-center gap-2"
                  >
                    <Plus className="w-3 h-4" />
                    <span className="font-semibold text-sm">Add Row</span>
                  </button>
                  {entries.some((entry) => entry?.selected) && (
                    <button
                      type="button"
                      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition flex justify-center items-center gap-2"
                      onClick={() => {
                        setEntries((prev) =>
                          prev.filter((row) => !row?.selected),
                        );
                      }}
                    >
                      <Trash2 className="w-3 h-4" />
                      <span className="font-semibold text-sm">Delete</span>
                    </button>
                  )}
                </div>
                <div className="flex gap-6 items-center justify-center">
                  <span className="font-normal">
                    Total Debit:{" "}
                    <span className="font-semibold">
                      {/* {sumOfDebit.toFixed(2)} */}
                      {sumOfAmount.toFixed(2)}
                    </span>
                  </span>
                  <span className="font-normal">
                    Total Credit:{" "}
                    <span className="font-semibold">
                      {/* {pcAmount.toFixed(2)} */}
                      {sumOfAmount.toFixed(2)}
                    </span>
                  </span>
                  {/* <span className="font-normal">
                        Diff:{" "}
                        <span className="font-semibold">
                          {(sumOfCredit - sumOfDebit)?.toFixed(2)}
                        </span>
                      </span> */}
                  <span className="font-medium">Difference:</span>{" "}
                  <span
                    className={`font-semibold ${Number(difference) === 0
                      ? "text-green-600"
                      : "text-red-600"
                      }`}
                  >
                    {difference}
                  </span>
                </div>

                {/* <div
                  ref={setupBillContainerRef}
                  className="flex gap-6 justify-center items-center"
                >
                  <Tooltip
                    title={!isAccountFocused ? "Please Select an Account" : ""}
                    arrow
                  >
                    <label
                      className={`text-md font-medium ${
                        !isAccountFocused
                          ? "opacity-50 cursor-not-allowed"
                          : "opacity-100 cursor-pointer"
                      } `}
                    >
                      Setup Bill
                      <input
                        disabled={!isAccountFocused}
                        className={`ml-2 w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500
        ${
          !isAccountFocused
            ? "opacity-50 cursor-not-allowed"
            : "opacity-100 cursor-pointer transition-opacity duration-300"
        }
      `}
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                    </label>
                  </Tooltip>
                  <label className="text-md font-medium">
                    Repeat Amount
                    <input
                      className="shadow-sm ml-2 border-gray-400 focus:ring-blue-500 focus:border-blue-500 rounded-md transition-all duration-500 ease-in-out w-6 h-6"
                      type="checkbox"
                      checked={isCheckedRepeatAmount}
                      onChange={(e) =>
                        setIsCheckedRepeatAmount(e.target.checked)
                      }
                    />
                  </label>
                  <label className="text-md font-medium">
                    Repeat Desc
                    <input
                      className="shadow-sm ml-2 border-gray-400 focus:ring-blue-500 focus:border-blue-500 rounded-md transition-all duration-500 ease-in-out w-6 h-6"
                      type="checkbox"
                      checked={isCheckedRepeatDesc}
                      onChange={(e) => setIsCheckedRepeatDesc(e.target.checked)}
                    />
                  </label>
                </div> */}
                {/* </div> */}
                {/* <div className="flex items-center justify-between w-30">
                  <label className="text-sm font-medium flex justify-center items-center gap-6">
                    <span>Doc Dt</span>
                  </label>
                  <input
                    type="date"
                    value={docDate}
                    onChange={(e) => setDocDate(e.target.value)}
                    className="bg-white ml-4 text-gray-700 border-gray-300 focus:ring-blue-500 focus:border-blue-500 px-2 py-1 rounded mt-1"
                  />
                </div> */}
                {/* <button
                  onClick={handleAddRow}
                  className="px-3 py-1 text-sm border rounded bg-gray-50 hover:bg-gray-100"
                >
                  Add Row
                </button> */}
              </div>
            </div>

            {modifyButton ? (
              <div className="justify-center items-center flex mt-4">
                <Tooltip
                  title={
                    isCommentEmpty
                      ? "Please enter description"
                      : // : isCreditZero
                      // ? "Credit must not be zero"
                      // : isDebitZero
                      // ? "Debit must not be zero"
                      !isDifferenceZero
                        ? "Credit and Debit must be equal"
                        : isAnyAccountEmpty
                          ? "Account must not be empty"
                          : isAnyAccountLength
                            ? "Account length must be equal to 8"
                            : isSelectedAccount
                              ? "Select Account from list"
                              : // : isCorrectLength
                              // ? "Account length is not 8"
                              ""
                  }
                  arrow
                >
                  <span>
                    {" "}
                    {/* Required wrapper because disabled button blocks pointer events */}
                    <button
                      onClick={onModifyVoucher}
                      disabled={isDisabled}
                      className={`px-3 py-2 text-white text-sm border rounded w-[270px] transition
                       ${isDisabled
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gray-700 hover:bg-black"
                        }`}
                    >
                      Modify
                    </button>
                  </span>
                </Tooltip>
              </div>
            ) : (
              <div className="justify-center items-center flex mt-8">
                {/* <button
                  onClick={onSaveVoucher}
                  className="px-3 py-2 text-white text-sm border rounded bg-gray-700 hover:bg-black w-[270px]"
                >
                  Save
                </button>*/}
                {/* <Tooltip title={isDisabled ? getTooltipMessage() : ""} arrow> */}
                <Tooltip
                  title={
                    isCommentEmpty
                      ? "Please enter a description"
                      : isCreditZero
                        ? "Enter PC Amount"
                        : isDebitZero
                          ? "Debit must not be zero"
                          : !isDifferenceZero
                            ? "Credit and Debit must be equal"
                            : isAnyAccountEmpty
                              ? "Account must not be empty"
                              : isAnyAccountLength
                                ? "Account length must be equal to 8"
                                : isSelectedAccount
                                  ? "Select Account from list"
                                  : ""
                  }
                  arrow
                >
                  <span>
                    {" "}
                    {/* Required wrapper because disabled button blocks pointer events */}
                    <button
                      onClick={onSaveVoucher}
                      disabled={isDisabled}
                      className={`px-3 py-2 text-white text-sm border rounded w-[270px] transition ${isDisabled
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gray-700 hover:bg-black"
                        }`}
                    >
                      Save
                    </button>
                  </span>
                </Tooltip>
              </div>
            )}
            {crPCModalOpen && (
              <Modal
                isOpen={crPCModalOpen}
                onClose={() => setCrPCModalOpen(false)}
                title={"Ledger List"}
                size="xxl"
                header={true}
              >
                <CreditCustomerList
                  defaultType="Cash"
                  handleCustomerSelect={handleCustomerSelect}
                />
                {/* <ProductListing/> */}
              </Modal>
              // <PettyCashAccountPopup setCrPCModalOpen={setCrPCModalOpen} />
            )}
            {drPCModalOpen && (
              <Modal
                isOpen={drPCModalOpen}
                onClose={() => setDrPCModalOpen(false)}
                title={"Voucher Account List"}
                size="xxl"
                header={true}
              >
                <CreditCustomerList
                  defaultType="Expenses"
                  handleCustomerSelect={handleDrCustomerSelect}
                />
                {/* <ProductListing/> */}
              </Modal>
              // <PettyCashAccountPopup setCrPCModalOpen={setCrPCModalOpen} />
            )}
          </>
        ) : (
          ""
        )}
        {voucherModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white rounded shadow-lg h-[68vh] flex flex-col max-w-4xl w-full mx-6 px-6">
              <div className="flex justify-between items-center py-4 border-b bg-white rounded-t sticky top-0 z-20">
                <h2 className="text-lg font-semibold">
                  Select Voucher Account
                </h2>
                <button
                  className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                  onClick={() => {
                    setVoucherModalOpen(false);
                    setSearchVoucherAccountTerm("");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>
              <div className="flex justify-left gap-8 overflow-y-auto mt-4">
                <div className="sticky top-0 z-20">
                  <nav className="space-y-1 mt-2 mr-4">
                    {types?.map(({ name, icon: Icon }) => (
                      <button
                        key={name}
                        onClick={() => setValue(name.toUpperCase())}
                        className={`w-full flex items-center justify-between px-3 py-2 text-sm font-medium rounded-lg transition-colors ${value === name.toUpperCase()
                          ? "bg-blue-100 text-blue-700 border border-blue-200"
                          : "text-gray-700 hover:bg-gray-100"
                          }`}
                      >
                        <div className="flex items-center">
                          <Icon className="w-4 h-4 mr-3" />
                          {name}
                        </div>
                      </button>
                    ))}
                  </nav>
                </div>
                <div className="mt-2">
                  <div className="relative flex-1 mr-2 mb-4">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                    <input
                      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white shadow-sm"
                      type="text"
                      placeholder="Search Account"
                      value={searchVoucherAccountTerm}
                      onChange={(e) =>
                        setSearchVoucherAccountTerm(e.target.value)
                      }
                    />
                    {searchVoucherAccountTerm && (
                      <button
                        type="button"
                        onClick={() => setSearchVoucherAccountTerm("")}
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      >
                        <ClearIcon fontSize="small" />
                      </button>
                    )}
                  </div>
                  {loading ? (
                    <p className="text-sm text-gray-600">Loading...</p>
                  ) : (
                    <p className="text-sm text-gray-600">
                      Showing {(filteredAccounts || accounts)?.length} accounts{" "}
                      {value !== "ALL" && `in ${value}`}
                    </p>
                  )}
                  <div className="bg-white mt-2 rounded-lg shadow-sm border border-gray-200 max-h-[70%] pb-2 overflow-y-auto w-[100%]">
                    <div className="overflow-x-auto">
                      <table className="w-full">
                        <thead className="bg-gray-200 border-b border-gray-200 sticky top-0 z-10">
                          <tr>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                              Account
                            </th>
                            <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                              Description
                            </th>
                            <th className="px-5 py-3 text-right text-xs font-medium text-gray-500 uppercase">
                              Balance
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {loading ? (
                            <tr>
                              <td colSpan="4" className="py-12 text-center">
                                <div className="flex flex-col items-center justify-center">
                                  <svg
                                    className="animate-spin h-8 w-8 text-blue-500 mb-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                  >
                                    <circle
                                      className="opacity-25"
                                      cx="12"
                                      cy="12"
                                      r="10"
                                      stroke="currentColor"
                                      strokeWidth="4"
                                    ></circle>
                                    <path
                                      className="opacity-75"
                                      fill="currentColor"
                                      d="M4 12a8 8 0 018-8v8z"
                                    ></path>
                                  </svg>
                                  <p className="text-sm text-gray-500">
                                    Loading accounts...
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ) : (filteredAccounts || accounts)?.length === 0 ? (
                            <tr>
                              <td colSpan="4" className="py-12 text-center">
                                <Search className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
                                <p className="text-lg font-medium text-gray-900 mb-1">
                                  No accounts found
                                </p>
                                <p className="text-sm text-gray-500">
                                  Try a different filter or search
                                </p>
                              </td>
                            </tr>
                          ) : (
                            (filteredAccounts || accounts)?.map((acc, i) => (
                              <tr
                                key={i}
                                onClick={() =>
                                  // handleDropdownSelectAccount(i, acc)
                                  // handleSelectAccount(i, acc)
                                  handleSelectAccount(selectedRowIndex, acc)
                                }
                                className="hover:bg-gray-50 cursor-pointer"
                              >
                                <td className="px-5 py-3 text-sm font-medium text-gray-900">
                                  {acc.ACCOUNT}
                                </td>
                                <td className="px-5 py-3 text-sm text-gray-700">
                                  {acc.DESCRIPTION}
                                </td>
                                <td
                                  className={`px-5 py-3 text-sm text-right font-medium ${acc.BALANCE > 0
                                    ? "text-green-600"
                                    : acc.BALANCE < 0
                                      ? "text-red-600"
                                      : "text-gray-700"
                                    }`}
                                >
                                  {formatBalance(acc.BALANCE)}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {pdcModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white rounded shadow-lg h-[68vh] flex flex-col max-w-4xl w-full mx-6 px-6">
              {/* Header */}
              <div className="flex justify-between items-center py-4 border-b bg-white rounded-t sticky top-0 z-20">
                <h2 className="text-lg font-semibold">Select PDC Account</h2>
                <button
                  className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                  onClick={() => {
                    setPdcModalOpen(false);
                    setPdcSearchTerm("");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>

              {/* Search */}
              <div className="mt-4 flex flex-col">
                <div className="relative flex-1 mr-2 mb-4">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white shadow-sm"
                    type="text"
                    placeholder="Search PDC Account"
                    value={pdcSearchTerm}
                    onChange={(e) => setPdcSearchTerm(e.target.value)}
                  />
                  {pdcSearchTerm && (
                    <button
                      type="button"
                      onClick={() => setPdcSearchTerm("")}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      <ClearIcon fontSize="small" />
                    </button>
                  )}
                </div>

                {/* Info label */}
                <p className="text-sm text-gray-600 mb-2">
                  Showing {(filteredPDCAccounts || accounts)?.length} PDC
                  accounts
                </p>

                {/* Table */}
                <div className="bg-white mt-2 rounded-lg shadow-sm border border-gray-200 max-h-[70%] pb-2 overflow-y-auto w-[100%]">
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead className="bg-gray-200 border-b border-gray-200 sticky top-0 z-10">
                        <tr>
                          <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Account
                          </th>
                          <th className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                            Description
                          </th>
                          <th className="px-5 py-3 text-right text-xs font-medium text-gray-500 uppercase">
                            Balance
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200">
                        {loading ? (
                          <tr>
                            <td colSpan="3" className="py-12 text-center">
                              <div className="flex flex-col items-center justify-center">
                                <svg
                                  className="animate-spin h-8 w-8 text-blue-500 mb-3"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v8z"
                                  ></path>
                                </svg>
                                <p className="text-sm text-gray-500">
                                  Loading PDC accounts...
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (filteredPDCAccounts || accounts)?.length === 0 ? (
                          <tr>
                            <td colSpan="3" className="py-12 text-center">
                              <Search className="w-12 h-12 text-gray-300 mb-3 mx-auto" />
                              <p className="text-lg font-medium text-gray-900 mb-1">
                                No PDC accounts found
                              </p>
                              <p className="text-sm text-gray-500">
                                Try a different filter or search term
                              </p>
                            </td>
                          </tr>
                        ) : (
                          (filteredPDCAccounts || accounts)?.map((acc, i) => (
                            <tr
                              key={i}
                              onClick={() => {
                                handleChangePdcAcc(
                                  pdcDropdownOpenIndex,
                                  "pdcAcc",
                                  acc.ACCOUNT,
                                );
                                setPdcModalOpen(false);
                              }}
                              className="hover:bg-gray-50 cursor-pointer"
                            >
                              <td className="px-5 py-3 text-sm font-medium text-gray-900">
                                {acc.ACCOUNT}
                              </td>
                              <td className="px-5 py-3 text-sm text-gray-700">
                                {acc.DESCRIPTION}
                              </td>
                              <td
                                className={`px-5 py-3 text-sm text-right font-medium ${acc.BALANCE > 0
                                  ? "text-green-600"
                                  : acc.BALANCE < 0
                                    ? "text-red-600"
                                    : "text-gray-700"
                                  }`}
                              >
                                {formatBalance(acc.BALANCE)}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isChecked && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white max-w-4xl rounded p-4">
              <div className="flex justify-between items-center mb-4">
                <h2 className="font-semibold">Voucher Setup Bill</h2>
                <button
                  type="button"
                  className="ml-2 text-gray-700 hover:text-gray-900"
                  onClick={() => {
                    setIsChecked(false);
                    setIsAccountFocused(false);
                    setSetupBillAccount("");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>
              <VoucherSetupBill
                selectedAccount={setupBillAccount}
                onDataToSend={onDataToRecieve}
                jvType={selectedVoucherType}
              />
            </div>
          </div>
        )}

        {deletePopup && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white w-[25%] h-[25%] rounded p-4">
              <div className="flex justify-between items-center">
                <h2 className="font-semibold">Delete Voucher</h2>
                <button
                  className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                  onClick={() => setDeletePopup(false)}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>

              <div className="flex flex-col justify-center items-center h-32 mt-4">
                {/* Delete Icon */}
                <div className="flex justify-center items-center bg-red-100 rounded-full p-3 mb-3">
                  <Trash2 className="w-6 h-6 text-red-600" />
                </div>

                {/* Confirmation Text */}
                <p className="text-sm text-gray-700 text-center">
                  Are you sure you want to delete{" "}
                  <span className="font-semibold">
                    {selectedVoucherType}: {pvnoFromAPI}
                  </span>{" "}
                  ?
                </p>

                {/* Action Buttons */}
                <div className="flex gap-3 mt-8">
                  <button
                    onClick={() => setDeletePopup(false)}
                    className="px-3 py-1 text-sm border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      onSubmitVoucherDeleteNo(modifyVoucherNo);
                    }}
                    // disabled={!modifyVoucherNo.trim()}
                    className={`bg-red-600 hover:bg-red-700 px-3 py-1 text-white text-sm border rounded transition-colors duration-200`}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {openSavePopup && (
          <div
            className="inset-0 fixed flex justify-center items-center bg-black bg-opacity-50 "
            style={{ zIndex: 150 }}
          >
            <div className="overflow-hidden relative text-left rounded-lg max-w-[290px] shadow-xl bg-white">
              {/* <button
  onClick={handleCloseSnackbar}
    class="absolute top-2 right-2 flex items-center justify-center p-2 bg-white text-black border-2 border-gray-300 text-base font-light w-8 h-8 rounded-md transition ease-in-out duration-300 hover:bg-red-600 hover:border-red-600 hover:text-white"
    type="button"
  >
    ×
  </button> */}
              <div className="p-4 pb-2">
                <div className="flex mx-auto bg-green-100 flex-shrink-0 items-center justify-center w-12 h-12 rounded-full animate-scale-pulse transition ease-in-out duration-600">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M20 7L9.00004 18L3.99994 13"
                        stroke="#000000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className="mt-3 text-center">
                  <span className="text-green-700 text-base font-semibold leading-6">
                    {/* {selectedVoucherType}: {savedVNO} Saved Succesfully! */}
                    {selectedVoucherType}: {pvnoFromAPI} Saved Succesfully!
                  </span>
                </div>
                <div className="my-3 mx-4">
                  <button
                    className="inline-flex p-2 bg-green-600 text-white text-base leading-6 font-medium justify-center w-full rounded-md shadow-sm"
                    type="button"
                    onClick={handleCloseSnackbar}
                  >
                    OK
                  </button>
                  {/* <button
        class="inline-flex mt-3 p-2 text-gray-800 text-base leading-6 font-medium justify-center w-full rounded-md border border-gray-300 bg-white shadow-sm"
        type="button"
      >
        Track my package
      </button> */}
                </div>
              </div>
            </div>
          </div>
        )}

        {openModifyPopup && (
          <div
            className="inset-0 fixed flex justify-center items-center bg-black bg-opacity-50"
            style={{ zIndex: 150 }}
          >
            <div className="overflow-hidden relative text-left rounded-lg max-w-[290px] shadow-xl bg-white">
              <div className="p-4 pb-2">
                <div className="flex mx-auto bg-yellow-100 flex-shrink-0 items-center justify-center w-12 h-12 rounded-full animate-scale-pulse transition ease-in-out duration-600">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 7L9.00004 18L3.99994 13"
                      stroke="#000000"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="mt-3 text-center">
                  <span className="text-yellow-700 text-base font-semibold leading-6">
                    {selectedVoucherDescription}: {modifiedVNO} Modified
                    Successfully!
                  </span>
                </div>
                <div className="my-3 mx-4">
                  <button
                    className="inline-flex p-2 bg-yellow-600 text-white text-base leading-6 font-medium justify-center w-full rounded-md shadow-sm"
                    type="button"
                    onClick={handleCloseSnackbar}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showDeleteConfirm && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-sm p-6 text-center">
              <h2 className="text-lg font-semibold mb-4 text-gray-800">
                Confirm Delete
              </h2>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to delete the selected rows? This action
                cannot be undone.
              </p>
              <div className="flex justify-center gap-3">
                <button
                  onClick={() => {
                    // setEntries((prev) => prev.filter((row) => !row.selected));
                    onDelete();
                    setShowDeleteConfirm(false);
                  }}
                  className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                >
                  Yes, Delete
                </button>
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={handleCloseSnackbar}
            severity="success"
            sx={{ width: "100%" }}
          >
            {selectedVoucherDescription} : {savedVNO} Saved Succesfully!
          </MuiAlert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={handleCloseSnackbar}
            severity="error"
            sx={{ width: "100%" }}
          >
            Failed to save voucher. Please try again!
          </MuiAlert>
        </Snackbar>

        <Snackbar
          open={openErrorModifySnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={handleCloseSnackbar}
            severity="error"
            sx={{ width: "100%" }}
          >
            Failed to modify voucher. Please try again!
          </MuiAlert>
        </Snackbar>
      </div>
      {/* )} */}
    </>
  );
};

export default PettyCash;
